import { Autocomplete, Box, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const UserAssignmentAutocomplete = ({
  assignmentId,
  setSelectedUser,
  selectedUser,
  isSubmit,
  type,
}) => {
  const users = useSelector((state) => state?.static?.users);
  const [_userName, setUserName] = useState('');
  const [selectedUserName, setSelectedUserName] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (users?.length > 0) {
      setOptions(
        users
          .filter((user) => user.isActive)
          .filter((user) =>
            ['local', 'development', 'preproduction'].includes(
              import.meta.env.VITE_NODE_ENV
            )
              ? user
              : user.roles.some((role) => {
                  return ['SCO', 'SLO', 'SAV'].includes(role.service.code);
                })
          )
      );
    }
  }, [users, assignmentId]);

  const handleChange = (event) => {
    setUserName(event.target.value);
  };

  useEffect(() => {
    if (users?.length > 0) {
      const user = users?.find((user) => {
        return user?._id === assignmentId;
      });
      setSelectedUserName(user ? user : null);
    }
  }, [users, selectedUser, assignmentId]);

  const handleFieldChange = async (event, value) => {
    setSelectedUser(value);
    setSelectedUserName(null);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Autocomplete
        sx={[
          {
            margin: 1,
            fontSize: '0.2rem',
            width: isSubmit ? 240 : 150,
          },
        ]}
        getOptionLabel={(option) => {
          return `(${type === 'ticket' ? option?.nbTicket : option?.nbTask}) ${
            option?.firstName
          } ${option?.lastName}`;
        }}
        isOptionEqualToValue={(option, value) => option?._id === value?._id}
        autoHighlight
        label="Assignation"
        id="assignation-bar"
        options={options}
        value={selectedUserName || selectedUser || null}
        onChange={handleFieldChange}
        renderOption={(props, _option) => {
          const { key: id, ...rest } = props;
          return (
            <Box style={{ fontSize: 12 }} key={id} {...rest}>
              {id}
            </Box>
          );
        }}
        renderInput={(params) => (
          <>
            <TextField
              {...params}
              placeholder="non assigné"
              onChange={handleChange}
              variant="outlined"
              size={isSubmit ? 'large' : 'small'}
              slotProps={{
                input: {
                  ...params.InputProps,
                  type: 'text',
                  style: { fontSize: 12 },
                },
              }}
            />
          </>
        )}
      />
    </Box>
  );
};

export default UserAssignmentAutocomplete;
